import { Component, OnInit } from '@angular/core';
import { NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';
import { Router } from '@angular/router';
// import { UserData } from '../../../@core/data/users';
// import { LayoutService } from '../../../@core/utils';
// import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SessionDetailsService } from '../../../pages/services/session-details.service';
import { AdminService } from '../../../pages/admin/service/admin.service';
import { takeUntil } from 'rxjs/operators';
import { UserData } from '../../../@core/data/users';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  admin: any;
  adminDetails: any;
  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [{ title: 'Profile', action: 'ProfileClicked()' }, { title: 'Log out', action: 'logout()' }];

  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserData,
    // private layoutService: LayoutService,
    private sessionDetailsService: SessionDetailsService,
    private service: AdminService, private router: Router,
  ) {
  }
  ngOnInit() {
    this.admin = this.sessionDetailsService.adminDetails || null;
    this.getSingleAdminData();
    this.currentTheme = this.themeService.currentTheme;

    this.userService.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = users.nick);
    this.menuService.onItemClick().subscribe((event) => {
      if (event.item.title === 'Log out') {
        this.openLogOut();
      } else if (event.item.title === 'Profile') {
        this.openProfilePage();
      }
    });
    // const { xl } = this.breakpointService.getBreakpointsMap();
    // this.themeService.onMediaQueryChange()
    //   .pipe(
    //     map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
    //     takeUntil(this.destroy$),
    //   )
    //   .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    // this.themeService.onThemeChange()
    //   .pipe(
    //     map(({ name }) => name),
    //     takeUntil(this.destroy$),
    //   )
    //   .subscribe(themeName => this.currentTheme = themeName);
  }
  openLogOut() {
    localStorage.clear();
    this.router.navigate(['/Admin/admin-login']);
  }
  openProfilePage() {
    this.router.navigate(['/pages/admin/admin-profile']);
  }
  getSingleAdminData() {
    const body = {
      superAdminId: this.admin.adminId,
    };
    this.service.viewSuperAdminDetails(body).subscribe(data => {
      if (this.apiResponseCheck(data)) {
        this.adminDetails = data.superAdminDetails;
      }
    });
  }
  apiResponseCheck(data) {
    if (data.responseStatus === 1) {
      return data;
    } else {
      return null;
    }
  }
  // this.menuService.onItemClick().pipe(filter(({ tag }) => tag === this.tag)).subscribe(bag => console.log(bag)); }

  // ngOnDestroy() {
  //   this.destroy$.next();
  //   this.destroy$.complete();
  // }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    // this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    // this.menuService.navigateHome();
    // return false;
    this.router.navigate(['/pages/dashboard']);
  }
}
